import React, { useRef, useEffect } from 'react';
import TenantFormAutocomplete from './TenantFormAutocomplete.js.jsx';
import styles from '../../../stylesheets/management_site/tenantForm.module.scss';

const TenantFormFirstNameField = ({
  label,
  name,
  id,
  type = 'text',
  size,
  className = '',
  defaultValue = '',
  required = false,
  floatAbove = false,
  enableAutocomplete = false,
  searchResults = [],
  isSearching = false,
  showAutocomplete = false,
  onInputChange,
  onSelectTenant,
  onHideAutocomplete,
  ...props
}) => {
  const labelClasses = `mdc-floating-label${floatAbove ? ' mdc-floating-label--float-above' : ''}`;
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target) &&
        showAutocomplete
      ) {
        onHideAutocomplete && onHideAutocomplete();
      }
    };

    if (showAutocomplete) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
  }, [showAutocomplete, onHideAutocomplete]);

  return (
    <div
      ref={containerRef}
      className={`pm-flex pm-flex-col ${styles.textFieldContainer}`}
    >
      <div className="mdc-form-field mdc-form-field--align-end">
        <div
          className="mdc-text-field pm-margin-none"
          data-mdc-auto-init="MDCTextField"
        >
          <label htmlFor={id} className={labelClasses}>
            {label}
          </label>
          <input
            type={type}
            name={name}
            id={id}
            className={`mdc-text-field__input ${className}`}
            defaultValue={defaultValue}
            required={required}
            size={size}
            onChange={enableAutocomplete ? onInputChange : undefined}
            {...props}
          />
        </div>
      </div>
      {enableAutocomplete && (
        <TenantFormAutocomplete
          searchResults={searchResults}
          isSearching={isSearching}
          showAutocomplete={showAutocomplete}
          onSelectTenant={onSelectTenant}
          onClose={onHideAutocomplete}
        />
      )}
    </div>
  );
};

export default TenantFormFirstNameField;
